// constants/googleAds.ts

export const GOOGLE_ADS_CONFIG = {
  // Google Analytics
  GA_MEASUREMENT_ID: 'G-GT65PSJ4FE',
  
  // Google Tag Manager
  GTM_ID: 'GTM-KD2JHQ2F',
  
  // Google Ads
  ADS_CONVERSION_ID: 'AW-16631687339',
  ADS_CONVERSION_LABEL: 'fGJbCNaMrb8ZEKvRzfo9',
  
  // Computed values
  get ADS_SEND_TO(): string {
    return `${this.ADS_CONVERSION_ID}/${this.ADS_CONVERSION_LABEL}`;
  },
  
  get GTM_URL(): string {
    return `https://www.googletagmanager.com/gtm.js?id=${this.GTM_ID}`;
  },
  
  get GA_URL(): string {
    return `https://www.googletagmanager.com/gtag/js?id=${this.GA_MEASUREMENT_ID}`;
  },
  
  get ADS_URL(): string {
    return `https://www.googletagmanager.com/gtag/js?id=${this.ADS_CONVERSION_ID}`;
  }
} as const;

// Type definitions for Google Ads events
export interface ConversionEventConfig {
  send_to: string;
  event_callback?: () => void;
  debug_mode?: boolean;
}

export type ConversionResult = {
  success: boolean;
  method: 'gtag_report_conversion' | 'gtag_fallback' | 'direct_redirect' | 'failed';
  message: string;
};